import styled from "styled-components";

export const Link = styled.div`
  font-size: 20px;
  font-weight: 600;
  min-width: 70px;
  text-align: center;
  padding: 0px 0px 10px 0px;
  color: #000;
  cursor: pointer;
  color: #88fefe;
  display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  background-color: ${(p) =>
    p.selected &&
    `
   border-bottom:3px solid #00a97c;
`};
@media(max-width:1024px){
padding: 0px;
}

`;

export const H1 = styled.h1`
  display: flex;
  margin: 0;
  font-size: 18px;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  ${(p) =>
    p.selected &&
    `
    border-bottom: 1px solid #fff;
`};


  @media (max-width: 1440px) {
    font-size: 16px;
    padding: 10px 15px;
  }
  @media (max-width: 1024px) {
    font-size: 15px;
    padding: 10px 20px;
    margin: 10px 0;
  }
`;

export const H2 = styled.h1`
  display: flex;
  margin: 0;
  font-size: 14px;
  color: white;
  font-weight: 400;
  padding: 10px 20px;
  cursor: pointer;
  text-transform: capitalize;
  ${(p) =>
    p.selected &&
    `
    background-color:#49494A;
    border-radius:8px;
`};


  @media (max-width: 1440px) {
    font-size: 16px;
    padding: 10px 15px;
  }
  @media (max-width: 1024px) {
    font-size: 15px;
    padding: 10px 20px;
    margin: 10px 0;
  }
`;

export const SubCatSection=styled.div`
@media (max-width:500px){
  display: none;
}
`

export const NavSection = styled.div`
  display: flex;
  margin: 25px 0;
  align-items: center;
  text-align: center;
  border-radius: 10px;
@media(max-width: 1024px){
  margin: 0px;
  /* display: flex;
  justify-content:flex-start;
  align-items:center;
  text-align:start; */

}
`;

export const NftGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;

  @media (max-width: 1899px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 15px;
  }
  @media (max-width: 1600px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
  }
  @media (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-gap: 30px;
  }
`;

export const NftGridWrapper = styled.div`
  background: linear-gradient(
    160.61deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 101.7%
  );
  border-width:  0px;
  border-style: solid;
  border-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(17.915px);
  border-radius: 30px;
`;

export const NftNewArivalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
  /* background: rgba(255, 255, 255, 0.2); */
  background: #262A2D;
  /* border-bottom: 2.5px solid #a73ee7; */
  backdrop-filter: blur(10.4167px);
  border-radius: 30px;
  position: relative;
  overflow: hidden;
      padding: 15px 0;
`;
export const NftNewArival = styled.img`
  width: 200px;
  height: 152px;
  aspect-ratio: auto 200 / 152;
  cursor: pointer;
  transition: 0.5s;
  &:hover{
    transform: scale(1.3);
  }
`;

export const NftNameWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: start;
  align-items: center;
  width: 100%;
  padding: 2px 20px 5px 20px;
`;

export const NftNameText = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-transform: capitalize;
  color: #ffffff;
`;

export const NftCountText = styled.text`
font-size: 14px;
font-weight: 400;
padding: 3px 0px 10px;
font-style: normal;
color: #FB9829;
`

export const LiveButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  background: #203736;
  border-radius: 4px;
  padding: 5px 10px;
`;
export const LiveLight = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 30px;
  background-color: white;
  margin: 0 3px;
`;
export const LiveButton = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
`;

export const PriceButtonContainer = styled.div`
  display: flex;
  margin: 10px 20px 20px 20px;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

export const PriceWrapper = styled.div`
  line-height: 22px;
  @media (max-width: 1440px) {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: start;
  }
`;

export const Pricevalue = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  text-transform: capitalize;
`;
export const PriceText = styled.text`
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 20px;
  text-transform: capitalize;
`;

export const NavSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 30px;
  }
  @media (max-width: 1024px) {
    /* flex-direction: column; */
    margin-bottom: 30px;
  }
  @media (max-width:500px){
    margin-bottom: 8px;
  }
`;
export const FilterWrapper = styled.div`
  @media(max-width:768px){
  width:100%;
}
  @media(max-width:1024px){
  /* width:100%; */
}
`;

export const SearchWrapper = styled.div`
position: relative;
`
export const SearchInput = styled.input`
  padding: 8px 8px 8px 35px;
  font-size: 14px;
  border: 1px solid #8A8AA0;
  border-radius: 4px;
  background-color: transparent;
  color: #8A8AA0;
  outline: none;
  font-family: 'Lato', sans-serif;
  @media(max-width:1024px){
    width: 100%;
  }
  @media (max-width:500px){
    width: 60vw;
  }
`

export const SubCatMobile = styled.div`
display: none;
@media (max-width:500px){
  display: block;
}
`

export const FilterContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
gap:15px;
margin-left: 10px;
`

export const SearchIcon = styled.img`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
`;

export const ImageWrapper = styled.div`
  margin: 0 10px;
`;
export const Image = styled.img`
width: 20px;
`;

export const DropDownSection = styled.div`
  background: #191919;
  border-radius: 8px;
  position: absolute;
  z-index: 999;
  left: 65%;
  border-radius: 10px;
  width: 45%;
  top: 120%;
  @media (max-width:500px){
    left: -142px;
  }
 
`;
export const ListWrapper = styled.div`
  background-color: #191919;
  border-radius: 15px;
  display: flex;
  justify-content: flex-start;
  padding: 15px 20px;
  /* margin: 15px 20px; */
  width: 100%;
   @media (max-width:500px){
    width: 180px;
  }
`;
export const List = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  cursor: pointer;
   @media (max-width:500px){
    line-height: 30px ;
  }
`;
